import React, { useEffect } from "react";
import NewsHeader from "../componets/NewsHeader";
import Header from "../componets/Header";
import { Box, Grid, Typography, Paper } from "@mui/material";
import Footer from "../componets/Footer";
import { red, yellow, orange } from "@mui/material/colors";
import about from "../../../../assets/abut.png";
import about1 from "../../../../assets/about1.png";
import abouts from "../../../../assets/aboutpage.png";
import missionIcon from "../../../../assets/mission.png";
import visionIcon from "../../../../assets/vision.png";
import philosophyIcon from "../../../../assets/philosophy.png";
import a1 from "../../../../assets/a1.png";
import a2 from "../../../../assets/a2.png";
import a3 from "../../../../assets/a3.png";
import a4 from "../../../../assets/a4.png";

import AOS from "aos";
import "aos/dist/aos.css";

const data = [
  {
    title: "Mission",
    color: red[500],
    icon: missionIcon,
    content:
      "To create an environment for children to learn through their own mistakes. This enables them to learn new tasks at their own pace in line with their own strengths and weaknesses. Helping children overcome the fear of trying new things.",
  },
  {
    title: "Vision",
    color: yellow[700],
    icon: visionIcon,
    content:
      "We want to create an enabling atmosphere to nurture the uniqueness of each child with positive relationships that support all round learning and development for lifelong success.",
  },
  {
    title: "Philosophy",
    color: orange[400],
    icon: philosophyIcon,
    content:
      "At PODAR PREP we follow the concept of ‘Supported Learning Pits’ by James Nottingham. This helps teachers understand that children go through a learning curve and how this curve can be supported for the success of each child.",
  },
];
const stats = [
  {
    icon: a1,
    value: "97",
    label: "Years",
  },
  {
    icon: a2,
    value: "149",
    label: "Podar International Schools",
  },
  {
    icon: a3,
    value: "225",
    label: "Podar Prep Preschools",
  },
  {
    icon: a4,
    value: "250000+",
    label: "Students",
  },
];

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
      mirror: false,
      offset: 100,
    });
  }, []);

  return (
    <>
      <NewsHeader />
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${abouts})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "auto",
          height: { xs: 200, md: 700 },
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: 2, md: 2 },
          mt: {xs:0,md:-10},
        }}
      >
        {/* Left - Text */}
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              color: "#fdce0d",
              fontSize: { xs: 20, md: 50 },
              width: "50%",
              fontWeight: "bold",
              fontFamily: "-moz-initial",
              ml: {xs:0,md:10},
            }}
          >
            About Podar Education Network
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          p: { xs: 3, md: 10 },
          textAlign: "center",
          mb: 10,
          position: "relative",
          color: "#000",
          backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${about})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Typography
          fontWeight={600}
          sx={{
            fontSize: { xs: 28, md: 50 },
            fontWeight: "bold",
            color: "#1d67ab",
            mb: 2,
            fontFamily: "-moz-initial",
          }}
        >
          About Podar Education Network
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 16, md: 19 },
            mb: 4,
            maxWidth: "95%",
            textAlign: "center",
            mx: "auto",
          }}
        >
          Established in <strong style={{ color: "#1d67ab" }}>1927</strong> by{" "}
          <strong style={{ color: "#1d67ab" }}>
            1Sheth Anandilal Podar; Podar Education Group
          </strong>
          has, from the very beginning been driven by the traditional Indian
          values of honesty, integrity and service. The father of our nation,
          <strong style={{ color: "#1d67ab" }}>
            {" "}
            Mahatma Gandhi, being the very first President of the Anandilal
            Podar Trust{" "}
          </strong>
          stands as testimony to this fact.
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 16, md: 19 },
            mb: 4,
            maxWidth: "95%",
            textAlign: "center",
            mx: "auto",
          }}
        >
          Our scholastic record, innovative learning methods and a strong
          commitment to delivering quality through integrity has helped us
          become a trusted name and an acknowledged leader in the nation through
          our wide network of top schools in India.
        </Typography>

        <Box sx={{ py: 10, backgroundColor: "#fff" }}>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            {stats.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box textAlign="center">
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.label}
                    sx={{ width: 80, height: 80, mb: 2 }}
                  />
                  <Typography
                    color="primary"
                    sx={{
                      fontWeight: "bold",
                      fontFamily: "-moz-initial",
                      fontSize: { xs: 30, md: 50 },
                    }}
                  >
                    {item.value}
                  </Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 10 }}>
          <Typography
            sx={{
              fontSize: { xs: 28, md: 50 },
              fontWeight: "bold",
              color: "#1d67ab",
              mb: 2,
              mt: 2,
              fontFamily: "-moz-initial",
            }}
          >
            About Podar Prep
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 16, md: 19 },
              mb: 4,
              maxWidth: "95%",
              textAlign: "center",
              mx: "auto",
            }}
          >
            At Podar Prep (formerly Podar Jumbo Kids), we’re excited to embrace
            the latest in early childhood education, inspired by{" "}
            <strong style={{ color: "#1d67ab" }}>NEP 2020 </strong> and
            complemented by insights from EYFS (UK) and EYLF (Australia). Our
            refreshed curriculum and new look are designed to offer a nurturing
            and engaging start to your child’s educational journey. Explore what
            many consider among the best preschool experiences in India, right
            here with us at Podar Prep.
          </Typography>
        </Box>

        <Grid container spacing={8} justifyContent="center">
          {data.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <Paper
                elevation={6}
                sx={{
                  border: `20px solid ${item.color}`,
                  p: { xs: 2, md: 4 },
                  height: 400,
                  borderRadius: 2,
                  textAlign: "center",
                }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  style={{ width: 60, height: 60, marginBottom: 16 }}
                />
                <Typography
                  fontWeight={700}
                  sx={{
                    fontSize: { xs: 22, md: 30 },
                    fontWeight: "bold",
                    color: "blue",
                    mb: 2,
                    mt: 2,
                    fontFamily: "-moz-initial",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: 14, md: 16 }, color: "text.secondary" }}
                >
                  {item.content}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Footer />
    </>
  );
};

export default AboutUs;
